(function () {
  'use strict';
  function boot() {
    if (window.atAdminDesignInitialized) return;
    window.atAdminDesignInitialized = true;
    document.body.classList.add('at-admin-redesign');
    var root = document.querySelector('.at-admin-shell');
    if (!root) return;
    var sidebar = root.querySelector('.at-admin-sidebar');
    var topbar = root.querySelector('.at-admin-unified-topbar');
    var mobile = window.matchMedia('(max-width: 760px)');
    var trigger;
    var close;
    var backdrop;
    var previousFocus;
    function setMenu(open) {
      if (!sidebar || !trigger) return;
      sidebar.classList.toggle('at-design-nav-open', open);
      backdrop.classList.toggle('at-design-nav-open', open);
      trigger.setAttribute('aria-expanded', String(open));
      if (mobile.matches) sidebar.inert = !open;
      if (open) {
        previousFocus = document.activeElement;
        close.focus();
      } else if (previousFocus && previousFocus.isConnected) previousFocus.focus();
    }
    if (sidebar && topbar) {
      sidebar.id = sidebar.id || 'at-design-sidebar';
      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'at-design-mobile-toggle';
      trigger.setAttribute('aria-label', window.ATLocale.t("ui.c0c346b2d168"));
      trigger.setAttribute('aria-controls', sidebar.id);
      trigger.setAttribute('aria-expanded', 'false');
      trigger.textContent = '☰';
      var brand = topbar.querySelector('.at-admin-unified-topbar__brand') || topbar;
      brand.prepend(trigger);
      close = document.createElement('button');
      close.type = 'button';
      close.className = 'at-design-mobile-close';
      close.textContent = window.ATLocale.t("ui.c2ae2c561b7e");
      sidebar.prepend(close);
      backdrop = document.createElement('button');
      backdrop.type = 'button';
      backdrop.className = 'at-design-nav-backdrop';
      backdrop.setAttribute('aria-label', window.ATLocale.t("ui.fe2fb897c735"));
      backdrop.setAttribute('tabindex', '-1');
      root.prepend(backdrop);
      trigger.addEventListener('click', function () { setMenu(true); });
      close.addEventListener('click', function () { setMenu(false); });
      backdrop.addEventListener('click', function () { setMenu(false); });
      document.addEventListener('keydown', function (event) {
        if (!mobile.matches || !sidebar.classList.contains('at-design-nav-open')) return;
        if (event.key === 'Escape') { event.preventDefault(); setMenu(false); }
        if (event.key === 'Tab') {
          var items = Array.from(sidebar.querySelectorAll('a[href], button, summary')).filter(function (el) { return el.getClientRects().length && !el.disabled; });
          var first = items[0];
          var last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      sidebar.addEventListener('click', function (event) {
        if (event.target.closest('a') && mobile.matches) setMenu(false);
      });
      mobile.addEventListener('change', function () { setMenu(false); sidebar.inert = mobile.matches; });
      sidebar.inert = mobile.matches;
    }
    function updateNavigation() {
      if (!sidebar) return;
      var currentPath = window.location.pathname.replace(/\/$/, '');
      var currentHash = window.location.hash;
      if (root.hasAttribute('data-at-inventory-page')) {
        var activeInventoryTab = root.querySelector('.at-inv-tabs [data-tab].is-active');
        currentHash = activeInventoryTab ? '#' + activeInventoryTab.getAttribute('data-tab') : (currentHash || '#transfers');
      }
      var currentView = new URLSearchParams(window.location.search).get('view') || '';
      var params = new URLSearchParams(window.location.search);
      var preview = params.get('preview_theme_id');
      var language = params.get('at_lang') || window.ATLocale?.language || 'ar';
      sidebar.querySelectorAll('[data-sales-center-label]').forEach(function(label){ label.textContent = language === 'en' ? 'Sales center' : 'مركز البيع'; });
      sidebar.querySelectorAll('a[href]').forEach(function (link) {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        if (url.origin === window.location.origin) {
          if (preview) url.searchParams.set('preview_theme_id', preview);
          url.searchParams.set('at_lang', language);
          link.setAttribute('href', url.pathname + url.search + url.hash);
        }
        var selected = url.pathname.replace(/\/$/, '') === currentPath && (!url.hash || url.hash === currentHash) && (url.searchParams.get('view') || '') === currentView;
        if (url.pathname.endsWith('/admin-inventory') && !currentHash) selected = selected && url.hash === '#transfers';
        link.classList.toggle('is-active', selected);
        if (selected) {
          link.setAttribute('aria-current', 'page');
          var group = link.closest('details');
          if (group) group.open = true;
        } else link.removeAttribute('aria-current');
      });
    }
    function tables() {
      document.querySelectorAll('.at-admin-shell table, .at-transfer-modal table, .at-sale-modal table, #saleEditModal table, #saleDetailsModal table, .modal table, [role=dialog] table').forEach(function (table) {
        if (!table.tHead) return;
        table.classList.add('at-design-table');
        if (table.parentElement) table.parentElement.setAttribute('data-at-design-table-wrap', '');
        var labels = Array.from(table.tHead.rows[table.tHead.rows.length - 1].cells).map(function (cell) { return cell.textContent.trim(); });
        Array.from(table.tBodies).forEach(function (body) {
          Array.from(body.rows).forEach(function (row) {
            Array.from(row.cells).forEach(function (cell, index) {
              if (cell.colSpan !== 1) return;
              var label = labels[index] || '';
              if (cell.getAttribute('data-at-cell-label') !== label) cell.setAttribute('data-at-cell-label', label);
            });
          });
        });
        table.querySelectorAll('.transaction-link,.invoice-link,.cell-one-line,.capital-badge,.profit-badge').forEach(function (el) {
          if (!el.querySelector('.at-design-fit-text') && el.childNodes.length === 1 && el.firstChild.nodeType === 3) {
            var span = document.createElement('span');
            span.className = 'at-design-fit-text';
            span.appendChild(el.firstChild);
            el.appendChild(span);
          }
        });
      });
    }
    function fitText() {
      if (mobile.matches) return;
      document.querySelectorAll('.at-design-table .at-design-fit-text').forEach(function (span) {
        span.style.removeProperty('font-size');
        span.classList.remove('at-design-text-wrap');
        var cell = span.closest('td');
        if (!cell || !cell.getClientRects().length) return;
        var available = cell.clientWidth - 10;
        var width = span.getBoundingClientRect().width;
        if (width > available && available > 0) {
          var size = parseFloat(getComputedStyle(span).fontSize);
          var next = Math.max(10, size * available / width);
          span.style.setProperty('font-size', next.toFixed(2) + 'px', 'important');
          if (span.getBoundingClientRect().width > available + 1) span.classList.add('at-design-text-wrap');
        }
      });
    }
    var queued = false;
    function refresh() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; tables(); fitText(); });
    }
    new MutationObserver(function (records) {
      if (records.some(function (r) { return r.type === 'childList'; })) refresh();
    }).observe(document.body, { subtree: true, childList: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('hashchange', updateNavigation);
    window.addEventListener('at:inventory-tab-changed', updateNavigation);
    window.addEventListener('load', refresh);
    if (document.fonts) document.fonts.ready.then(refresh);
    updateNavigation();
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();




